import { useMemo } from 'react';
import envConfig from '../envs/envConfig';
import { Remotes } from '../envs/types';
import { useRemoteOverrides } from '../providers/RemoteOverridesProvider';

const useRemotes = (remotes = envConfig.remotes): Remotes | undefined => {
  const overrides = useRemoteOverrides();

  const newRemotes = useMemo(
    () =>
      remotes?.map((remote) => {
        const scope = remote.scope;
        const override = overrides[scope];

        if (override) {
          return {
            ...remote,
            url: override,
          };
        }

        return remote;
      }),
    [remotes, overrides]
  );

  return newRemotes as Remotes;
};

export default useRemotes;
